var et = Object.defineProperty;
var rt = (e, t, n) => t in e ? et(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var qe = (e, t, n) => rt(e, typeof t != "symbol" ? t + "" : t, n);
import dr, { forwardRef as tt, useImperativeHandle as nt, Fragment as ot, useMemo as be, useRef as Ge, useReducer as at, useEffect as ar, useCallback as M, Component as it } from "react";
import m from "prop-types";
var ur = { exports: {} }, Le = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _r;
function ut() {
  if (_r) return Le;
  _r = 1;
  var e = dr, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, u = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(d, g, f) {
    var y, _ = {}, I = null, z = null;
    f !== void 0 && (I = "" + f), g.key !== void 0 && (I = "" + g.key), g.ref !== void 0 && (z = g.ref);
    for (y in g) o.call(g, y) && !a.hasOwnProperty(y) && (_[y] = g[y]);
    if (d && d.defaultProps) for (y in g = d.defaultProps, g) _[y] === void 0 && (_[y] = g[y]);
    return { $$typeof: t, type: d, key: I, ref: z, props: _, _owner: u.current };
  }
  return Le.Fragment = n, Le.jsx = l, Le.jsxs = l, Le;
}
var Me = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wr;
function ct() {
  return wr || (wr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = dr, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), d = Symbol.for("react.context"), g = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), y = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), I = Symbol.for("react.lazy"), z = Symbol.for("react.offscreen"), J = Symbol.iterator, ee = "@@iterator";
    function _e(r) {
      if (r === null || typeof r != "object")
        return null;
      var i = J && r[J] || r[ee];
      return typeof i == "function" ? i : null;
    }
    var N = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function T(r) {
      {
        for (var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), v = 1; v < i; v++)
          s[v - 1] = arguments[v];
        we("error", r, s);
      }
    }
    function we(r, i, s) {
      {
        var v = N.ReactDebugCurrentFrame, E = v.getStackAddendum();
        E !== "" && (i += "%s", s = s.concat([E]));
        var w = s.map(function(h) {
          return String(h);
        });
        w.unshift("Warning: " + i), Function.prototype.apply.call(console[r], console, w);
      }
    }
    var We = !1, De = !1, Ne = !1, Y = !1, Oe = !1, X;
    X = Symbol.for("react.module.reference");
    function re(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === o || r === a || Oe || r === u || r === f || r === y || Y || r === z || We || De || Ne || typeof r == "object" && r !== null && (r.$$typeof === I || r.$$typeof === _ || r.$$typeof === l || r.$$typeof === d || r.$$typeof === g || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === X || r.getModuleId !== void 0));
    }
    function Ye(r, i, s) {
      var v = r.displayName;
      if (v)
        return v;
      var E = i.displayName || i.name || "";
      return E !== "" ? s + "(" + E + ")" : s;
    }
    function ce(r) {
      return r.displayName || "Context";
    }
    function k(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && T("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case o:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case u:
          return "StrictMode";
        case f:
          return "Suspense";
        case y:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case d:
            var i = r;
            return ce(i) + ".Consumer";
          case l:
            var s = r;
            return ce(s._context) + ".Provider";
          case g:
            return Ye(r, r.render, "ForwardRef");
          case _:
            var v = r.displayName || null;
            return v !== null ? v : k(r.type) || "Memo";
          case I: {
            var E = r, w = E._payload, h = E._init;
            try {
              return k(h(w));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var D = Object.assign, F = 0, Ke, xe, se, P, Be, Re, te;
    function Ae() {
    }
    Ae.__reactDisabledLog = !0;
    function Z() {
      {
        if (F === 0) {
          Ke = console.log, xe = console.info, se = console.warn, P = console.error, Be = console.group, Re = console.groupCollapsed, te = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: Ae,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        F++;
      }
    }
    function Ue() {
      {
        if (F--, F === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: D({}, r, {
              value: Ke
            }),
            info: D({}, r, {
              value: xe
            }),
            warn: D({}, r, {
              value: se
            }),
            error: D({}, r, {
              value: P
            }),
            group: D({}, r, {
              value: Be
            }),
            groupCollapsed: D({}, r, {
              value: Re
            }),
            groupEnd: D({}, r, {
              value: te
            })
          });
        }
        F < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var $ = N.ReactCurrentDispatcher, le;
    function ne(r, i, s) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (E) {
            var v = E.stack.trim().match(/\n( *(at )?)/);
            le = v && v[1] || "";
          }
        return `
` + le + r;
      }
    }
    var fe = !1, K;
    {
      var pe = typeof WeakMap == "function" ? WeakMap : Map;
      K = new pe();
    }
    function B(r, i) {
      if (!r || fe)
        return "";
      {
        var s = K.get(r);
        if (s !== void 0)
          return s;
      }
      var v;
      fe = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var w;
      w = $.current, $.current = null, Z();
      try {
        if (i) {
          var h = function() {
            throw Error();
          };
          if (Object.defineProperty(h.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(h, []);
            } catch (q) {
              v = q;
            }
            Reflect.construct(r, [], h);
          } else {
            try {
              h.call();
            } catch (q) {
              v = q;
            }
            r.call(h.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (q) {
            v = q;
          }
          r();
        }
      } catch (q) {
        if (q && v && typeof q.stack == "string") {
          for (var b = q.stack.split(`
`), C = v.stack.split(`
`), A = b.length - 1, j = C.length - 1; A >= 1 && j >= 0 && b[A] !== C[j]; )
            j--;
          for (; A >= 1 && j >= 0; A--, j--)
            if (b[A] !== C[j]) {
              if (A !== 1 || j !== 1)
                do
                  if (A--, j--, j < 0 || b[A] !== C[j]) {
                    var L = `
` + b[A].replace(" at new ", " at ");
                    return r.displayName && L.includes("<anonymous>") && (L = L.replace("<anonymous>", r.displayName)), typeof r == "function" && K.set(r, L), L;
                  }
                while (A >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        fe = !1, $.current = w, Ue(), Error.prepareStackTrace = E;
      }
      var ye = r ? r.displayName || r.name : "", Er = ye ? ne(ye) : "";
      return typeof r == "function" && K.set(r, Er), Er;
    }
    function He(r, i, s) {
      return B(r, !1);
    }
    function Ve(r) {
      var i = r.prototype;
      return !!(i && i.isReactComponent);
    }
    function oe(r, i, s) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return B(r, Ve(r));
      if (typeof r == "string")
        return ne(r);
      switch (r) {
        case f:
          return ne("Suspense");
        case y:
          return ne("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case g:
            return He(r.render);
          case _:
            return oe(r.type, i, s);
          case I: {
            var v = r, E = v._payload, w = v._init;
            try {
              return oe(w(E), i, s);
            } catch {
            }
          }
        }
      return "";
    }
    var ae = Object.prototype.hasOwnProperty, U = {}, de = N.ReactDebugCurrentFrame;
    function H(r) {
      if (r) {
        var i = r._owner, s = oe(r.type, r._source, i ? i.type : null);
        de.setExtraStackFrame(s);
      } else
        de.setExtraStackFrame(null);
    }
    function ve(r, i, s, v, E) {
      {
        var w = Function.call.bind(ae);
        for (var h in r)
          if (w(r, h)) {
            var b = void 0;
            try {
              if (typeof r[h] != "function") {
                var C = Error((v || "React class") + ": " + s + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw C.name = "Invariant Violation", C;
              }
              b = r[h](i, h, v, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              b = A;
            }
            b && !(b instanceof Error) && (H(E), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", s, h, typeof b), H(null)), b instanceof Error && !(b.message in U) && (U[b.message] = !0, H(E), T("Failed %s type: %s", s, b.message), H(null));
          }
      }
    }
    var rr = Array.isArray;
    function je(r) {
      return rr(r);
    }
    function tr(r) {
      {
        var i = typeof Symbol == "function" && Symbol.toStringTag, s = i && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return s;
      }
    }
    function c(r) {
      try {
        return p(r), !1;
      } catch {
        return !0;
      }
    }
    function p(r) {
      return "" + r;
    }
    function O(r) {
      if (c(r))
        return T("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", tr(r)), p(r);
    }
    var x = N.ReactCurrentOwner, S = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Q, V, ie;
    ie = {};
    function Te(r) {
      if (ae.call(r, "ref")) {
        var i = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function Fe(r) {
      if (ae.call(r, "key")) {
        var i = Object.getOwnPropertyDescriptor(r, "key").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function ge(r, i) {
      if (typeof r.ref == "string" && x.current && i && x.current.stateNode !== i) {
        var s = k(x.current.type);
        ie[s] || (T('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', k(x.current.type), r.ref), ie[s] = !0);
      }
    }
    function Pe(r, i) {
      {
        var s = function() {
          Q || (Q = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        s.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: s,
          configurable: !0
        });
      }
    }
    function Se(r, i) {
      {
        var s = function() {
          V || (V = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        s.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: s,
          configurable: !0
        });
      }
    }
    var Ce = function(r, i, s, v, E, w, h) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: r,
        key: i,
        ref: s,
        props: h,
        // Record the component responsible for creating this element.
        _owner: w
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function ke(r, i, s, v, E) {
      {
        var w, h = {}, b = null, C = null;
        s !== void 0 && (O(s), b = "" + s), Fe(i) && (O(i.key), b = "" + i.key), Te(i) && (C = i.ref, ge(i, E));
        for (w in i)
          ae.call(i, w) && !S.hasOwnProperty(w) && (h[w] = i[w]);
        if (r && r.defaultProps) {
          var A = r.defaultProps;
          for (w in A)
            h[w] === void 0 && (h[w] = A[w]);
        }
        if (b || C) {
          var j = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          b && Pe(h, j), C && Se(h, j);
        }
        return Ce(r, b, C, E, v, x.current, h);
      }
    }
    var Ie = N.ReactCurrentOwner, vr = N.ReactDebugCurrentFrame;
    function me(r) {
      if (r) {
        var i = r._owner, s = oe(r.type, r._source, i ? i.type : null);
        vr.setExtraStackFrame(s);
      } else
        vr.setExtraStackFrame(null);
    }
    var nr;
    nr = !1;
    function or(r) {
      return typeof r == "object" && r !== null && r.$$typeof === t;
    }
    function gr() {
      {
        if (Ie.current) {
          var r = k(Ie.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hr(r) {
      return "";
    }
    var mr = {};
    function Vr(r) {
      {
        var i = gr();
        if (!i) {
          var s = typeof r == "string" ? r : r.displayName || r.name;
          s && (i = `

Check the top-level render call using <` + s + ">.");
        }
        return i;
      }
    }
    function yr(r, i) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var s = Vr(i);
        if (mr[s])
          return;
        mr[s] = !0;
        var v = "";
        r && r._owner && r._owner !== Ie.current && (v = " It was passed a child from " + k(r._owner.type) + "."), me(r), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, v), me(null);
      }
    }
    function br(r, i) {
      {
        if (typeof r != "object")
          return;
        if (je(r))
          for (var s = 0; s < r.length; s++) {
            var v = r[s];
            or(v) && yr(v, i);
          }
        else if (or(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var E = _e(r);
          if (typeof E == "function" && E !== r.entries)
            for (var w = E.call(r), h; !(h = w.next()).done; )
              or(h.value) && yr(h.value, i);
        }
      }
    }
    function qr(r) {
      {
        var i = r.type;
        if (i == null || typeof i == "string")
          return;
        var s;
        if (typeof i == "function")
          s = i.propTypes;
        else if (typeof i == "object" && (i.$$typeof === g || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        i.$$typeof === _))
          s = i.propTypes;
        else
          return;
        if (s) {
          var v = k(i);
          ve(s, r.props, "prop", v, r);
        } else if (i.PropTypes !== void 0 && !nr) {
          nr = !0;
          var E = k(i);
          T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof i.getDefaultProps == "function" && !i.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Gr(r) {
      {
        for (var i = Object.keys(r.props), s = 0; s < i.length; s++) {
          var v = i[s];
          if (v !== "children" && v !== "key") {
            me(r), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), me(null);
            break;
          }
        }
        r.ref !== null && (me(r), T("Invalid attribute `ref` supplied to `React.Fragment`."), me(null));
      }
    }
    function hr(r, i, s, v, E, w) {
      {
        var h = re(r);
        if (!h) {
          var b = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var C = Hr();
          C ? b += C : b += gr();
          var A;
          r === null ? A = "null" : je(r) ? A = "array" : r !== void 0 && r.$$typeof === t ? (A = "<" + (k(r.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : A = typeof r, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, b);
        }
        var j = ke(r, i, s, E, w);
        if (j == null)
          return j;
        if (h) {
          var L = i.children;
          if (L !== void 0)
            if (v)
              if (je(L)) {
                for (var ye = 0; ye < L.length; ye++)
                  br(L[ye], r);
                Object.freeze && Object.freeze(L);
              } else
                T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              br(L, r);
        }
        return r === o ? Gr(j) : qr(j), j;
      }
    }
    function Jr(r, i, s) {
      return hr(r, i, s, !0);
    }
    function Xr(r, i, s) {
      return hr(r, i, s, !1);
    }
    var Zr = Xr, Qr = Jr;
    Me.Fragment = o, Me.jsx = Zr, Me.jsxs = Qr;
  }()), Me;
}
process.env.NODE_ENV === "production" ? ur.exports = ut() : ur.exports = ct();
var G = ur.exports;
function he(e, t, n, o) {
  function u(a) {
    return a instanceof n ? a : new n(function(l) {
      l(a);
    });
  }
  return new (n || (n = Promise))(function(a, l) {
    function d(y) {
      try {
        f(o.next(y));
      } catch (_) {
        l(_);
      }
    }
    function g(y) {
      try {
        f(o.throw(y));
      } catch (_) {
        l(_);
      }
    }
    function f(y) {
      y.done ? a(y.value) : u(y.value).then(d, g);
    }
    f((o = o.apply(e, t || [])).next());
  });
}
function Ee(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, o, u, a, l = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return l.next = d(0), l.throw = d(1), l.return = d(2), typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function d(f) {
    return function(y) {
      return g([f, y]);
    };
  }
  function g(f) {
    if (o) throw new TypeError("Generator is already executing.");
    for (; l && (l = 0, f[0] && (n = 0)), n; ) try {
      if (o = 1, u && (a = f[0] & 2 ? u.return : f[0] ? u.throw || ((a = u.return) && a.call(u), 0) : u.next) && !(a = a.call(u, f[1])).done) return a;
      switch (u = 0, a && (f = [f[0] & 2, a.value]), f[0]) {
        case 0:
        case 1:
          a = f;
          break;
        case 4:
          return n.label++, { value: f[1], done: !1 };
        case 5:
          n.label++, u = f[1], f = [0];
          continue;
        case 7:
          f = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (f[0] === 6 || f[0] === 2)) {
            n = 0;
            continue;
          }
          if (f[0] === 3 && (!a || f[1] > a[0] && f[1] < a[3])) {
            n.label = f[1];
            break;
          }
          if (f[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = f;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(f);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      f = t.call(e, n);
    } catch (y) {
      f = [6, y], u = 0;
    } finally {
      o = a = 0;
    }
    if (f[0] & 5) throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}
function Dr(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var o = n.call(e), u, a = [], l;
  try {
    for (; (t === void 0 || t-- > 0) && !(u = o.next()).done; ) a.push(u.value);
  } catch (d) {
    l = { error: d };
  } finally {
    try {
      u && !u.done && (n = o.return) && n.call(o);
    } finally {
      if (l) throw l.error;
    }
  }
  return a;
}
function Or(e, t, n) {
  if (n || arguments.length === 2) for (var o = 0, u = t.length, a; o < u; o++)
    (a || !(o in t)) && (a || (a = Array.prototype.slice.call(t, 0, o)), a[o] = t[o]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var st = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function ze(e, t) {
  var n = lt(e);
  if (typeof n.path != "string") {
    var o = e.webkitRelativePath;
    Object.defineProperty(n, "path", {
      value: typeof t == "string" ? t : typeof o == "string" && o.length > 0 ? o : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return n;
}
function lt(e) {
  var t = e.name, n = t && t.lastIndexOf(".") !== -1;
  if (n && !e.type) {
    var o = t.split(".").pop().toLowerCase(), u = st.get(o);
    u && Object.defineProperty(e, "type", {
      value: u,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var ft = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function pt(e) {
  return he(this, void 0, void 0, function() {
    return Ee(this, function(t) {
      return Xe(e) && dt(e.dataTransfer) ? [2, yt(e.dataTransfer, e.type)] : vt(e) ? [2, gt(e)] : Array.isArray(e) && e.every(function(n) {
        return "getFile" in n && typeof n.getFile == "function";
      }) ? [2, mt(e)] : [2, []];
    });
  });
}
function dt(e) {
  return Xe(e);
}
function vt(e) {
  return Xe(e) && Xe(e.target);
}
function Xe(e) {
  return typeof e == "object" && e !== null;
}
function gt(e) {
  return cr(e.target.files).map(function(t) {
    return ze(t);
  });
}
function mt(e) {
  return he(this, void 0, void 0, function() {
    var t;
    return Ee(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, Promise.all(e.map(function(o) {
            return o.getFile();
          }))];
        case 1:
          return t = n.sent(), [2, t.map(function(o) {
            return ze(o);
          })];
      }
    });
  });
}
function yt(e, t) {
  return he(this, void 0, void 0, function() {
    var n, o;
    return Ee(this, function(u) {
      switch (u.label) {
        case 0:
          return e.items ? (n = cr(e.items).filter(function(a) {
            return a.kind === "file";
          }), t !== "drop" ? [2, n] : [4, Promise.all(n.map(bt))]) : [3, 2];
        case 1:
          return o = u.sent(), [2, xr(Lr(o))];
        case 2:
          return [2, xr(cr(e.files).map(function(a) {
            return ze(a);
          }))];
      }
    });
  });
}
function xr(e) {
  return e.filter(function(t) {
    return ft.indexOf(t.name) === -1;
  });
}
function cr(e) {
  if (e === null)
    return [];
  for (var t = [], n = 0; n < e.length; n++) {
    var o = e[n];
    t.push(o);
  }
  return t;
}
function bt(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return Rr(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? Mr(t) : Rr(e);
}
function Lr(e) {
  return e.reduce(function(t, n) {
    return Or(Or([], Dr(t), !1), Dr(Array.isArray(n) ? Lr(n) : [n]), !1);
  }, []);
}
function Rr(e) {
  var t = e.getAsFile();
  if (!t)
    return Promise.reject("".concat(e, " is not a File"));
  var n = ze(t);
  return Promise.resolve(n);
}
function ht(e) {
  return he(this, void 0, void 0, function() {
    return Ee(this, function(t) {
      return [2, e.isDirectory ? Mr(e) : Et(e)];
    });
  });
}
function Mr(e) {
  var t = e.createReader();
  return new Promise(function(n, o) {
    var u = [];
    function a() {
      var l = this;
      t.readEntries(function(d) {
        return he(l, void 0, void 0, function() {
          var g, f, y;
          return Ee(this, function(_) {
            switch (_.label) {
              case 0:
                if (d.length) return [3, 5];
                _.label = 1;
              case 1:
                return _.trys.push([1, 3, , 4]), [4, Promise.all(u)];
              case 2:
                return g = _.sent(), n(g), [3, 4];
              case 3:
                return f = _.sent(), o(f), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                y = Promise.all(d.map(ht)), u.push(y), a(), _.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(d) {
        o(d);
      });
    }
    a();
  });
}
function Et(e) {
  return he(this, void 0, void 0, function() {
    return Ee(this, function(t) {
      return [2, new Promise(function(n, o) {
        e.file(function(u) {
          var a = ze(u, e.fullPath);
          n(a);
        }, function(u) {
          o(u);
        });
      })];
    });
  });
}
var _t = function(e, t) {
  if (e && t) {
    var n = Array.isArray(t) ? t : t.split(","), o = e.name || "", u = (e.type || "").toLowerCase(), a = u.replace(/\/.*$/, "");
    return n.some(function(l) {
      var d = l.trim().toLowerCase();
      return d.charAt(0) === "." ? o.toLowerCase().endsWith(d) : d.endsWith("/*") ? a === d.replace(/\/.*$/, "") : u === d;
    });
  }
  return !0;
};
function Ar(e) {
  return Ot(e) || Dt(e) || zr(e) || wt();
}
function wt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Dt(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ot(e) {
  if (Array.isArray(e)) return sr(e);
}
function jr(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(u) {
      return Object.getOwnPropertyDescriptor(e, u).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Tr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jr(Object(n), !0).forEach(function(o) {
      $r(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jr(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function $r(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function $e(e, t) {
  return At(e) || Rt(e, t) || zr(e, t) || xt();
}
function xt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zr(e, t) {
  if (e) {
    if (typeof e == "string") return sr(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sr(e, t);
  }
}
function sr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function Rt(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o = [], u = !0, a = !1, l, d;
    try {
      for (n = n.call(e); !(u = (l = n.next()).done) && (o.push(l.value), !(t && o.length === t)); u = !0)
        ;
    } catch (g) {
      a = !0, d = g;
    } finally {
      try {
        !u && n.return != null && n.return();
      } finally {
        if (a) throw d;
      }
    }
    return o;
  }
}
function At(e) {
  if (Array.isArray(e)) return e;
}
var jt = "file-invalid-type", Tt = "file-too-large", Ft = "file-too-small", Pt = "too-many-files", St = function(t) {
  t = Array.isArray(t) && t.length === 1 ? t[0] : t;
  var n = Array.isArray(t) ? "one of ".concat(t.join(", ")) : t;
  return {
    code: jt,
    message: "File type must be ".concat(n)
  };
}, Fr = function(t) {
  return {
    code: Tt,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, Pr = function(t) {
  return {
    code: Ft,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, Ct = {
  code: Pt,
  message: "Too many files"
};
function Wr(e, t) {
  var n = e.type === "application/x-moz-file" || _t(e, t);
  return [n, n ? null : St(t)];
}
function Nr(e, t, n) {
  if (ue(e.size))
    if (ue(t) && ue(n)) {
      if (e.size > n) return [!1, Fr(n)];
      if (e.size < t) return [!1, Pr(t)];
    } else {
      if (ue(t) && e.size < t) return [!1, Pr(t)];
      if (ue(n) && e.size > n) return [!1, Fr(n)];
    }
  return [!0, null];
}
function ue(e) {
  return e != null;
}
function kt(e) {
  var t = e.files, n = e.accept, o = e.minSize, u = e.maxSize, a = e.multiple, l = e.maxFiles, d = e.validator;
  return !a && t.length > 1 || a && l >= 1 && t.length > l ? !1 : t.every(function(g) {
    var f = Wr(g, n), y = $e(f, 1), _ = y[0], I = Nr(g, o, u), z = $e(I, 1), J = z[0], ee = d ? d(g) : null;
    return _ && J && !ee;
  });
}
function Ze(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function Je(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function Sr(e) {
  e.preventDefault();
}
function It(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function Lt(e) {
  return e.indexOf("Edge/") !== -1;
}
function Mt() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return It(e) || Lt(e);
}
function W() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(o) {
    for (var u = arguments.length, a = new Array(u > 1 ? u - 1 : 0), l = 1; l < u; l++)
      a[l - 1] = arguments[l];
    return t.some(function(d) {
      return !Ze(o) && d && d.apply(void 0, [o].concat(a)), Ze(o);
    });
  };
}
function $t() {
  return "showOpenFilePicker" in window;
}
function zt(e) {
  if (ue(e)) {
    var t = Object.entries(e).filter(function(n) {
      var o = $e(n, 2), u = o[0], a = o[1], l = !0;
      return Yr(u) || (console.warn('Skipped "'.concat(u, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), l = !1), (!Array.isArray(a) || !a.every(Kr)) && (console.warn('Skipped "'.concat(u, '" because an invalid file extension was provided.')), l = !1), l;
    }).reduce(function(n, o) {
      var u = $e(o, 2), a = u[0], l = u[1];
      return Tr(Tr({}, n), {}, $r({}, a, l));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function Wt(e) {
  if (ue(e))
    return Object.entries(e).reduce(function(t, n) {
      var o = $e(n, 2), u = o[0], a = o[1];
      return [].concat(Ar(t), [u], Ar(a));
    }, []).filter(function(t) {
      return Yr(t) || Kr(t);
    }).join(",");
}
function Nt(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function Yt(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function Yr(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function Kr(e) {
  return /^.*\.[\w]+$/.test(e);
}
var Kt = ["children"], Bt = ["open"], Ut = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], Ht = ["refKey", "onChange", "onClick"];
function Vt(e) {
  return Jt(e) || Gt(e) || Br(e) || qt();
}
function qt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gt(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Jt(e) {
  if (Array.isArray(e)) return lr(e);
}
function ir(e, t) {
  return Qt(e) || Zt(e, t) || Br(e, t) || Xt();
}
function Xt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Br(e, t) {
  if (e) {
    if (typeof e == "string") return lr(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return lr(e, t);
  }
}
function lr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function Zt(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o = [], u = !0, a = !1, l, d;
    try {
      for (n = n.call(e); !(u = (l = n.next()).done) && (o.push(l.value), !(t && o.length === t)); u = !0)
        ;
    } catch (g) {
      a = !0, d = g;
    } finally {
      try {
        !u && n.return != null && n.return();
      } finally {
        if (a) throw d;
      }
    }
    return o;
  }
}
function Qt(e) {
  if (Array.isArray(e)) return e;
}
function Cr(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(u) {
      return Object.getOwnPropertyDescriptor(e, u).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function R(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Cr(Object(n), !0).forEach(function(o) {
      fr(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Cr(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function fr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Qe(e, t) {
  if (e == null) return {};
  var n = en(e, t), o, u;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (u = 0; u < a.length; u++)
      o = a[u], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
  }
  return n;
}
function en(e, t) {
  if (e == null) return {};
  var n = {}, o = Object.keys(e), u, a;
  for (a = 0; a < o.length; a++)
    u = o[a], !(t.indexOf(u) >= 0) && (n[u] = e[u]);
  return n;
}
var er = /* @__PURE__ */ tt(function(e, t) {
  var n = e.children, o = Qe(e, Kt), u = rn(o), a = u.open, l = Qe(u, Bt);
  return nt(t, function() {
    return {
      open: a
    };
  }, [a]), /* @__PURE__ */ dr.createElement(ot, null, n(R(R({}, l), {}, {
    open: a
  })));
});
er.displayName = "Dropzone";
var Ur = {
  disabled: !1,
  getFilesFromEvent: pt,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
er.defaultProps = Ur;
er.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: m.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: m.objectOf(m.arrayOf(m.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: m.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: m.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: m.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: m.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: m.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: m.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: m.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: m.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: m.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: m.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: m.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: m.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: m.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: m.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: m.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: m.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: m.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: m.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: m.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: m.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: m.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: m.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: m.func
};
var pr = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function rn() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = R(R({}, Ur), e), n = t.accept, o = t.disabled, u = t.getFilesFromEvent, a = t.maxSize, l = t.minSize, d = t.multiple, g = t.maxFiles, f = t.onDragEnter, y = t.onDragLeave, _ = t.onDragOver, I = t.onDrop, z = t.onDropAccepted, J = t.onDropRejected, ee = t.onFileDialogCancel, _e = t.onFileDialogOpen, N = t.useFsAccessApi, T = t.autoFocus, we = t.preventDropOnDocument, We = t.noClick, De = t.noKeyboard, Ne = t.noDrag, Y = t.noDragEventsBubbling, Oe = t.onError, X = t.validator, re = be(function() {
    return Wt(n);
  }, [n]), Ye = be(function() {
    return zt(n);
  }, [n]), ce = be(function() {
    return typeof _e == "function" ? _e : kr;
  }, [_e]), k = be(function() {
    return typeof ee == "function" ? ee : kr;
  }, [ee]), D = Ge(null), F = Ge(null), Ke = at(tn, pr), xe = ir(Ke, 2), se = xe[0], P = xe[1], Be = se.isFocused, Re = se.isFileDialogActive, te = Ge(typeof window < "u" && window.isSecureContext && N && $t()), Ae = function() {
    !te.current && Re && setTimeout(function() {
      if (F.current) {
        var p = F.current.files;
        p.length || (P({
          type: "closeDialog"
        }), k());
      }
    }, 300);
  };
  ar(function() {
    return window.addEventListener("focus", Ae, !1), function() {
      window.removeEventListener("focus", Ae, !1);
    };
  }, [F, Re, k, te]);
  var Z = Ge([]), Ue = function(p) {
    D.current && D.current.contains(p.target) || (p.preventDefault(), Z.current = []);
  };
  ar(function() {
    return we && (document.addEventListener("dragover", Sr, !1), document.addEventListener("drop", Ue, !1)), function() {
      we && (document.removeEventListener("dragover", Sr), document.removeEventListener("drop", Ue));
    };
  }, [D, we]), ar(function() {
    return !o && T && D.current && D.current.focus(), function() {
    };
  }, [D, T, o]);
  var $ = M(function(c) {
    Oe ? Oe(c) : console.error(c);
  }, [Oe]), le = M(function(c) {
    c.preventDefault(), c.persist(), ve(c), Z.current = [].concat(Vt(Z.current), [c.target]), Je(c) && Promise.resolve(u(c)).then(function(p) {
      if (!(Ze(c) && !Y)) {
        var O = p.length, x = O > 0 && kt({
          files: p,
          accept: re,
          minSize: l,
          maxSize: a,
          multiple: d,
          maxFiles: g,
          validator: X
        }), S = O > 0 && !x;
        P({
          isDragAccept: x,
          isDragReject: S,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), f && f(c);
      }
    }).catch(function(p) {
      return $(p);
    });
  }, [u, f, $, Y, re, l, a, d, g, X]), ne = M(function(c) {
    c.preventDefault(), c.persist(), ve(c);
    var p = Je(c);
    if (p && c.dataTransfer)
      try {
        c.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return p && _ && _(c), !1;
  }, [_, Y]), fe = M(function(c) {
    c.preventDefault(), c.persist(), ve(c);
    var p = Z.current.filter(function(x) {
      return D.current && D.current.contains(x);
    }), O = p.indexOf(c.target);
    O !== -1 && p.splice(O, 1), Z.current = p, !(p.length > 0) && (P({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), Je(c) && y && y(c));
  }, [D, y, Y]), K = M(function(c, p) {
    var O = [], x = [];
    c.forEach(function(S) {
      var Q = Wr(S, re), V = ir(Q, 2), ie = V[0], Te = V[1], Fe = Nr(S, l, a), ge = ir(Fe, 2), Pe = ge[0], Se = ge[1], Ce = X ? X(S) : null;
      if (ie && Pe && !Ce)
        O.push(S);
      else {
        var ke = [Te, Se];
        Ce && (ke = ke.concat(Ce)), x.push({
          file: S,
          errors: ke.filter(function(Ie) {
            return Ie;
          })
        });
      }
    }), (!d && O.length > 1 || d && g >= 1 && O.length > g) && (O.forEach(function(S) {
      x.push({
        file: S,
        errors: [Ct]
      });
    }), O.splice(0)), P({
      acceptedFiles: O,
      fileRejections: x,
      type: "setFiles"
    }), I && I(O, x, p), x.length > 0 && J && J(x, p), O.length > 0 && z && z(O, p);
  }, [P, d, re, l, a, g, I, z, J, X]), pe = M(function(c) {
    c.preventDefault(), c.persist(), ve(c), Z.current = [], Je(c) && Promise.resolve(u(c)).then(function(p) {
      Ze(c) && !Y || K(p, c);
    }).catch(function(p) {
      return $(p);
    }), P({
      type: "reset"
    });
  }, [u, K, $, Y]), B = M(function() {
    if (te.current) {
      P({
        type: "openDialog"
      }), ce();
      var c = {
        multiple: d,
        types: Ye
      };
      window.showOpenFilePicker(c).then(function(p) {
        return u(p);
      }).then(function(p) {
        K(p, null), P({
          type: "closeDialog"
        });
      }).catch(function(p) {
        Nt(p) ? (k(p), P({
          type: "closeDialog"
        })) : Yt(p) ? (te.current = !1, F.current ? (F.current.value = null, F.current.click()) : $(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : $(p);
      });
      return;
    }
    F.current && (P({
      type: "openDialog"
    }), ce(), F.current.value = null, F.current.click());
  }, [P, ce, k, N, K, $, Ye, d]), He = M(function(c) {
    !D.current || !D.current.isEqualNode(c.target) || (c.key === " " || c.key === "Enter" || c.keyCode === 32 || c.keyCode === 13) && (c.preventDefault(), B());
  }, [D, B]), Ve = M(function() {
    P({
      type: "focus"
    });
  }, []), oe = M(function() {
    P({
      type: "blur"
    });
  }, []), ae = M(function() {
    We || (Mt() ? setTimeout(B, 0) : B());
  }, [We, B]), U = function(p) {
    return o ? null : p;
  }, de = function(p) {
    return De ? null : U(p);
  }, H = function(p) {
    return Ne ? null : U(p);
  }, ve = function(p) {
    Y && p.stopPropagation();
  }, rr = be(function() {
    return function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, p = c.refKey, O = p === void 0 ? "ref" : p, x = c.role, S = c.onKeyDown, Q = c.onFocus, V = c.onBlur, ie = c.onClick, Te = c.onDragEnter, Fe = c.onDragOver, ge = c.onDragLeave, Pe = c.onDrop, Se = Qe(c, Ut);
      return R(R(fr({
        onKeyDown: de(W(S, He)),
        onFocus: de(W(Q, Ve)),
        onBlur: de(W(V, oe)),
        onClick: U(W(ie, ae)),
        onDragEnter: H(W(Te, le)),
        onDragOver: H(W(Fe, ne)),
        onDragLeave: H(W(ge, fe)),
        onDrop: H(W(Pe, pe)),
        role: typeof x == "string" && x !== "" ? x : "presentation"
      }, O, D), !o && !De ? {
        tabIndex: 0
      } : {}), Se);
    };
  }, [D, He, Ve, oe, ae, le, ne, fe, pe, De, Ne, o]), je = M(function(c) {
    c.stopPropagation();
  }, []), tr = be(function() {
    return function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, p = c.refKey, O = p === void 0 ? "ref" : p, x = c.onChange, S = c.onClick, Q = Qe(c, Ht), V = fr({
        accept: re,
        multiple: d,
        type: "file",
        style: {
          display: "none"
        },
        onChange: U(W(x, pe)),
        onClick: U(W(S, je)),
        tabIndex: -1
      }, O, F);
      return R(R({}, V), Q);
    };
  }, [F, n, d, pe, o]);
  return R(R({}, se), {}, {
    isFocused: Be && !o,
    getRootProps: rr,
    getInputProps: tr,
    rootRef: D,
    inputRef: F,
    open: U(B)
  });
}
function tn(e, t) {
  switch (t.type) {
    case "focus":
      return R(R({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return R(R({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return R(R({}, pr), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return R(R({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return R(R({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return R(R({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections
      });
    case "reset":
      return R({}, pr);
    default:
      return e;
  }
}
function kr() {
}
const nn = "M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z", on = ({ width: e = 50, height: t = 43, style: n = {} }) => /* @__PURE__ */ G.jsx("svg", { className: "uploader-icon", xmlns: "http://www.w3.org/2000/svg", style: n, width: e, height: t, viewBox: "0 0 50 43", children: /* @__PURE__ */ G.jsx("path", { d: nn }) }), an = ({ isDragActive: e, isDragAccept: t, isDragReject: n }) => {
  const o = ["uploader-default-placeholder"];
  return t ? o.push("drag-accept") : n ? o.push("drag-reject") : e && o.push("drag-active"), /* @__PURE__ */ G.jsxs("div", { className: o.join(" "), children: [
    /* @__PURE__ */ G.jsx(on, {}),
    /* @__PURE__ */ G.jsx("div", { className: "placeholder-text", children: "Try dropping some files here, or click to select files to upload." })
  ] });
};
class Ir extends it {
  constructor() {
    super(...arguments);
    qe(this, "onDrop", (n, o) => {
      const { onChange: u } = this.props;
      u(n, o);
    });
  }
  render() {
    const { name: n, disabled: o, multiple: u, accept: a, placeholder: l } = this.props;
    return /* @__PURE__ */ G.jsx(er, { onDrop: this.onDrop, multiple: u, accept: a, disabled: o, children: ({ getRootProps: d, getInputProps: g, isDragActive: f, isDragAccept: y, isDragReject: _ }) => /* @__PURE__ */ G.jsxs(
      "div",
      {
        ...d(),
        children: [
          /* @__PURE__ */ G.jsx("input", { name: n, ...g() }),
          /* @__PURE__ */ G.jsx(l, { isDragActive: f, isDragAccept: y, isDragReject: _ })
        ]
      }
    ) });
  }
}
qe(Ir, "propTypes", {
  name: m.string,
  disabled: m.bool,
  multiple: m.bool,
  onChange: m.func.isRequired,
  placeholder: m.oneOfType([
    m.string,
    m.func
  ]),
  accept: m.objectOf(m.arrayOf(m.string))
}), qe(Ir, "defaultProps", {
  multiple: !1,
  disabled: !1,
  placeholder: an
});
export {
  Ir as FileSelector,
  on as FileSelectorIcon
};
